<script lang="ts" setup>
import type { SubjectCode } from '~/models/Subject'
import { useI18n } from 'vue-i18n'
import Button from '~/components/ui/Button.vue'

const { subjectCode, legacy } = defineProps<{ subjectCode: SubjectCode, legacy?: boolean }>()

const { t } = useI18n()
</script>

<template>
  <Button
    :to="{ name: 'subject_upcoming', params: { subject: subjectCode.toLowerCase() } }"
    shade="light"
    size="lg"
    v-bind="$attrs"
  >
    {{ t('filters.toNewSubject') }}
  </Button>
</template>
